import { css, htmlArray } from "../helpers/webComponents";

/** CSS affecting the {@link HealthBarComponent} */
const styles: string = css`
    .health-bars {
        display: flex;
        justify-content: space-between;
        padding: 5px;
    }

    .health-bar-name-and-bar {
        display: flex;
    }

    .health-bar-box {
        width: 500px;
        height: 30px;
    }

    .health-bar-fill {
        height: 80%;
        background-color: red;
        border-radius: 5px;
        border: 1px solid white;
    }

    .health-bar-border {
        background-color: #ffffff;
        border: 1px solid black;
        border-radius: 5px;
        margin: 0;
    }
`;

export class HealthBarComponent extends HTMLElement {
    private healthPlayer: number = 100;
    private healthBoss: number = 100;

    public setHealthPlayer(health: number): void {
        this.healthPlayer = health;
        this.render();
    }

    public setHealthBoss(health: number): void {
        this.healthBoss = health;
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const elements: HTMLElement[] = htmlArray`
            <style>
                ${styles}
            </style>
            <div class="health-bars">
                ${this.renderHealthBar()}
                ${this.renderBossHealthBar()}
            </div>
            `;

        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }

        this.shadowRoot.append(...elements);
    }

    private renderHealthBar(): string {
        let healthBar: string = "<div class='health-bar-name-and-bar'><p>Healthbar Player:</p><div class='health-bar-box'>";
        const healthPercentage: number = (this.healthPlayer / 100) * 100;
        healthBar += `<div class='health-bar-fill' style='width: ${healthPercentage}%;'></div></div></div>`;
        return healthBar;
    }

    private renderBossHealthBar(): string {
        let healthBar: string = "<div class='health-bar-name-and-bar'><p>Healthbar Player:</p><div class='health-bar-box'>";
        const healthPercentage: number = (this.healthBoss / 100) * 100;
        healthBar += `<div class='health-bar-fill' style='width: ${healthPercentage}%;'></div></div></div>`;
        return healthBar;
    }
}
